const declareRelationTypeMap = {
  'response': 'response',
  'precedence': 'precedence',
  'succession': 'succession',
  'coexistence': 'coexistence',
  'exclusion': 'exclusion',
  'not-coexistence': 'not_coexistence',
  'not_coexistence': 'not_coexistence',
  'not coexistence': 'not_coexistence',
  'not co-existence': 'not_coexistence',
  'not co_existence': 'not_coexistence',
  'notcoexistence': 'not_coexistence',
  'resp_existence': 'resp_existence',
  'resp-existence': 'resp_existence',
  'resp existence': 'resp_existence',
  'altresponse': 'alt_response',
  'alt_response': 'alt_response',
  'alt-response': 'alt_response',
  'alt response': 'alt_response',
  'altprecedence': 'alt_precedence',
  'alt_precedence': 'alt_precedence',
  'alt-precedence': 'alt_precedence',
  'alt precedence': 'alt_precedence',
  'altsuccession': 'alt_succession',
  'alt_succession': 'alt_succession',
  'alt-succession': 'alt_succession',
  'alt succession': 'alt_succession',
  'chainresponse': 'chain_response',
  'chain_response': 'chain_response',
  'chain-response': 'chain_response',
  'chain response': 'chain_response',
  'chainprecedence': 'chain_precedence',
  'chain_precedence': 'chain_precedence',
  'chain-precedence': 'chain_precedence',
  'chain precedence': 'chain_precedence',
  'chainsuccession': 'chain_succession',
  'chain_succession': 'chain_succession',
  'chain-succession': 'chain_succession',
  'chain succession': 'chain_succession',
  'resp_absence': 'resp_absence',
  'resp-absence': 'resp_absence',
  'resp absence': 'resp_absence',
  'neg_response': 'neg_response',
  'neg-response': 'neg_response',
  'neg response': 'neg_response',
  'neg_precedence': 'neg_precedence',
  'neg-precedence': 'neg_precedence',
  'neg precedence': 'neg_precedence',
  'neg_succession': 'neg_succession',
  'neg-succession': 'neg_succession',
  'neg succession': 'neg_succession',
  'neg_alt_response': 'neg_alt_response',
  'neg-alt-response': 'neg_alt_response',
  'neg alt response': 'neg_alt_response',
  'neg_alt_precedence': 'neg_alt_precedence',
  'neg-alt-precedence': 'neg_alt_precedence',
  'neg alt precedence': 'neg_alt_precedence',
  'neg_alt_succession': 'neg_alt_succession',
  'neg-alt-succession': 'neg_alt_succession',
  'neg alt succession': 'neg_alt_succession',
  'neg_chain_response': 'neg_chain_response',
  'neg-chain-response': 'neg_chain_response',
  'neg chain response': 'neg_chain_response',
  'neg_chain_precedence': 'neg_chain_precedence',
  'neg-chain-precedence': 'neg_chain_precedence',
  'neg chain precedence': 'neg_chain_precedence',
  'neg_chain_succession': 'neg_chain_succession',
  'neg-chain-succession': 'neg_chain_succession',
  'neg chain succession': 'neg_chain_succession',
  'respondedexistence': 'resp_existence',
};
export default declareRelationTypeMap;
